import { render, staticRenderFns } from "./FollowView.vue?vue&type=template&id=65cb900a&"
import script from "./FollowView.vue?vue&type=script&lang=js&"
export * from "./FollowView.vue?vue&type=script&lang=js&"
import style0 from "./FollowView.vue?vue&type=style&index=0&id=65cb900a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports